import {useReducer} from 'react'
import {FAILURE, PENDING, SUCCESS} from '../../constants'
const ActionTypes = {
  FAILURE,
  PENDING,
  SUCCESS,
}
const InitialState = {
  data: {},
  error: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        data: action.payload || [],
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetGroupReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default Reducer

export {ActionTypes, InitialState, useGetGroupReducer}
